import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddDesignationRes;
export const addDesignationTodo = createAsyncThunk('AddDesignation', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'superadmin/designation',
            data: {
                "name": data?.designation,
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddDesignationRes = res.data

    } catch (error) {
        return AddDesignationRes = error.response.data
    }
})